import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Checkmark16Regular } from '@fluentui/react-icons';
import { cn } from '../../utils/cn';

function Checkbox({
  className,
  size = 'md',
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  size?: 'sm' | 'md';
}) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'peer shrink-0 rounded border border-neutral-300 bg-white transition-colors outline-hidden',
        size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4',
        'focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:ring-offset-1',
        'data-[state=checked]:bg-primary-600 data-[state=checked]:border-primary-600 data-[state=checked]:text-white',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:border-red-500 aria-invalid:ring-2 aria-invalid:ring-red-500/20',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current"
      >
        <Checkmark16Regular className={size === 'sm' ? 'size-3' : 'size-3.5'} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
